import React from "react";
import CartItem from "../components/CartItem";

export default function Cart({ cart, removeFromCart }) {
  const total = cart.reduce((sum, item) => sum + item.price, 0);

  return (
    <div className="cart-container">
<button className="confirm-btn">Confirm Rental</button>

      <h2 className="text-xl font-bold mb-4">Your Cart</h2>
      {cart.map(item => (
        <CartItem key={item.id} item={item} removeFromCart={removeFromCart} />
      ))}
      <p className="cart-container">Total / day: ₹{total}</p>
    </div>
  );
}